import { render, staticRenderFns } from "./PaymentControls.vue?vue&type=template&id=572210b0&scoped=true"
import script from "./PaymentControls.vue?vue&type=script&lang=js"
export * from "./PaymentControls.vue?vue&type=script&lang=js"
import style0 from "./PaymentControls.vue?vue&type=style&index=0&id=572210b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572210b0",
  null
  
)

export default component.exports